/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BatesZipTaskStatus,
    BatesZipTaskStatusFromJSON,
    BatesZipTaskStatusFromJSONTyped,
    BatesZipTaskStatusToJSON,
    ZipUrl,
    ZipUrlFromJSON,
    ZipUrlFromJSONTyped,
    ZipUrlToJSON,
} from './';

/**
 * 
 * @export
 * @interface BatesZipView
 */
export interface BatesZipView {
    /**
     * 
     * @type {string}
     * @memberof BatesZipView
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BatesZipView
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof BatesZipView
     */
    productionSetId?: string;
    /**
     * 
     * @type {BatesZipTaskStatus}
     * @memberof BatesZipView
     */
    status?: BatesZipTaskStatus;
    /**
     * 
     * @type {Date}
     * @memberof BatesZipView
     */
    createdDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BatesZipView
     */
    modifiedDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof BatesZipView
     */
    progressPercentage?: number;
    /**
     * 
     * @type {Array<ZipUrl>}
     * @memberof BatesZipView
     */
    zipUrls?: Array<ZipUrl> | null;
}

export function BatesZipViewFromJSON(json: any): BatesZipView {
    return BatesZipViewFromJSONTyped(json, false);
}

export function BatesZipViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatesZipView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'productionSetId': !exists(json, 'productionSetId') ? undefined : json['productionSetId'],
        'status': !exists(json, 'status') ? undefined : BatesZipTaskStatusFromJSON(json['status']),
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'progressPercentage': !exists(json, 'progressPercentage') ? undefined : json['progressPercentage'],
        'zipUrls': !exists(json, 'zipUrls') ? undefined : (json['zipUrls'] === null ? null : (json['zipUrls'] as Array<any>).map(ZipUrlFromJSON)),
    };
}

export function BatesZipViewToJSON(value?: BatesZipView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'userId': value.userId,
        'productionSetId': value.productionSetId,
        'status': BatesZipTaskStatusToJSON(value.status),
        'createdDate': value.createdDate === undefined ? undefined : (value.createdDate.toISOString()),
        'modifiedDate': value.modifiedDate === undefined ? undefined : (value.modifiedDate === null ? null : value.modifiedDate.toISOString()),
        'progressPercentage': value.progressPercentage,
        'zipUrls': value.zipUrls === undefined ? undefined : (value.zipUrls === null ? null : (value.zipUrls as Array<any>).map(ZipUrlToJSON)),
    };
}


